mutation CreateFixedAudience($audience: AudienceCreateInput!) {
    audienceCreate(input: $audience) {
        audience {
            id
            name
            htmlUrl
            htmlUrlPath
            htmlUrlPathForList
            membershipStats {
                totalCount {
                    value
                    suffix
                    prefix
                    formatted
                }
            }
            createdTime
            isRecentlyCreated
            description
        }
    }
}
